import { formatMMtoHHMM } from '@mummssoftware/utils/formatters';
import { sumDTOMap, noAttMap } from '../Context/constants';
import defaults from '../../translations/en.json';

const getattValue = (props: any) =>
  JSON.parse(props.data.visitattrsumdto).find(
    (a: any) => a.name === props.colDef.field,
  );

export const attributeDurationValueGetter = (props: any) => {
  const { data, colDef } = props;
  if (!data.visitattrsumdto) return '';
  let totalInMins;
  if (colDef.field === defaults.noAttribute) {
    totalInMins = data[noAttMap.get(defaults.total) || ''] || 0;
  } else {
    const atts = getattValue(props);
    totalInMins = (atts && atts[sumDTOMap.get(defaults.total) || '']) || 0;
  }
  return formatMMtoHHMM(totalInMins);
};

export const attributeCountValueGetter = (props: any) => {
  const { data, colDef } = props;
  if (!data.visitattrsumdto) return '';
  let count;
  if (colDef.field === defaults.noAttribute) {
    count = data[noAttMap.get(colDef.headerName) || ''] || 0;
  } else {
    const atts = getattValue(props);
    count = (atts && atts[sumDTOMap.get(colDef.headerName) || '']) || 0;
  }
  return count;
};

export const totalValueGetter = (props: any) => {
  const { data } = props;

  if (!data.visitattrsumdto) {
    return '';
  }
  const atts = JSON.parse(data.visitattrsumdto);
  return (
    atts.reduce((seed: any, att: any) => seed + att.sumattrcnt, 0) +
    data.noattributescnt
  );
};

export const formatName = (firstname: string, lastname: string) =>
  `${lastname}, ${firstname}`;

export const workerValueGetter = (props: any) => {
  const {
    data,
    data: { firstname, lastname },
  } = props;
  if (data.firstname === defaults.total || !data.visitattrsumdto) {
    return '';
  }
  return formatName(firstname, lastname);
};

export const credentialsValueGetter = (props: any) => {
  const {
    data: { credentials },
  } = props;
  return credentials || '';
};

export const travelTimeValueGetter = ({
  data: { unduplicatedtraveltime },
}: any) => formatMMtoHHMM(unduplicatedtraveltime);
